import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "7a78a106-4ee8-4fe4-a10a-9f03669d8c69",
    content: "Lower at low frequencies than at high frequencies",
    options: {},
  },
  {
    id: "6f75c52a-9df2-4c2a-ac34-8c46f9d6b18a",
    content: "Not dependent on frequency, i.e. constant with frequency.",
    options: {},
  },
  {
    id: "8167ca17-e0e5-4ac1-8d3c-734a6a815f71",
    content: "Higher at low frequencies compared to high frequencies.",
    options: {},
  },
  { id: "4e7b062b-6604-44fe-b0ca-d042c33a5c5e", content: "Cannot be determined.", options: {} },
];

export const task: Task = {
  id: "f618b99d-6738-4b75-b534-e9cfa666b2cd",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8167ca17-e0e5-4ac1-8d3c-734a6a815f71"],
};
